<template>
  <Badge v-if="value" :theme="theme">{{ label }}</Badge>
</template>

<script>
import Badge from '@/components/Badge'

export default {
  props: {
    value: String,
  },
  computed: {
    theme() {
      switch (this.value) {
        case 'complaint':
          return 'error'
        default:
          return 'secondary'
      }
    },
    label() {
      switch (this.value) {
        case 'complaint':
          return this.$tc('taskType' + this.value.toTitleCase())
        default:
          return this.$tc('taskTypeDefault')
      }
    },
  },
  components: {
    Badge,
  },
}
</script>

<style lang="scss"></style>
